module.exports = __webpack_public_path__ + "img/stock0.efa9442d.png";